import { Observable } from "rxjs";

import st from "lib/utils/index";
import { CompanyRepository } from "lib/repositories/index";
import { createFormInstance } from "modules/utils/index";
import { fetchCurrentCompany } from "modules/auth";

export const INITIALIZE_VIEW = "settings/BillingSettingsView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "settings/BillingSettingsView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "settings/BillingSettingsView/UPDATE_MODEL";
export const VALIDATE = "settings/BillingSettingsView/VALIDATE";
export const SUBMIT = "settings/BillingSettingsView/SUBMIT";
export const FETCH_SUBMIT_START = "settings/BillingSettingsView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "settings/BillingSettingsView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "settings/BillingSettingsView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.settings.BillingSettingsView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model } }, errors) => {
    // errors.add(`model.name`, st.validators.presence(model.name))
  },
  submitModel: ({ form: { initialModel, model } }) => {
    const serialize = (company) => ({
      id: company.id,
      invoice_company_name: company.invoice_company_name,
      invoice_nip: company.invoice_nip,
      invoice_street_address: company.invoice_street_address,
      invoice_postal_code: company.invoice_postal_code,
      invoice_city: company.invoice_city,
      invoice_country_name: company.invoice_country_name,
      invoice_email: company.invoice_email,
      invoice_phone_number: company.invoice_phone_number,
    });
    return CompanyRepository.update(serialize(model), serialize(initialModel));
  },
});

const initialState = {
  form: formInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(INITIALIZE_VIEW).map(() => {
      const company = getState().auth.company.model;
      return initializeModel(company);
    }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).mapTo(fetchCurrentCompany()),
];

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/BillingSettingsView/index.js